import { render, staticRenderFns } from "./RipaNfia.vue?vue&type=template&id=63067100"
import script from "./RipaNfia.vue?vue&type=script&lang=js"
export * from "./RipaNfia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports